import { render, staticRenderFns } from "./setSpec.vue?vue&type=template&id=604d95b8&scoped=true"
import script from "./setSpec.vue?vue&type=script&lang=js"
export * from "./setSpec.vue?vue&type=script&lang=js"
import style0 from "./setSpec.vue?vue&type=style&index=0&id=604d95b8&prod&lang=stylus"
import style1 from "./setSpec.vue?vue&type=style&index=1&id=604d95b8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604d95b8",
  null
  
)

export default component.exports